import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import { dwLogging } from "../../../../shared/hooks/useFetchLogin";
import AllUrls from "../../Utils/axr";
import { useAppSelector } from "../../hooks";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import useBrightspeedHeaders from "../../hooks/useBrightspeedHeader";
import DwLogutil from "../../Utils/DwLogutil";

type Props = {
  user: {
    first_name: string;
    last_name: string;
    email: string;
  };
  id: string;
};
export const ExtoleReferal = ({ user, id }: Props) => {
  const userData = useAppSelector((state) => state?.user);
  const headers = useBrightspeedHeaders();

  useEffect(() => {
    (function (c: any, e: any, k: any, l: any, a: any) {
      c[e] = c[e] || {};
      for (c[e].q = c[e].q || []; a < l.length; ) k(l[a++], c[e]);
    })(
      window,
      "extole",
      function (c: string | number, e: { [x: string]: () => void; q: any }) {
        e[c] =
          e[c] ||
          function () {
            e.q.push([c, arguments]);
          };
      },
      ["createZone"],
      0
    );
    (window as any)?.extole.createZone({
      name: "web_account_management",
      element_id: `extole_zone_web_account_management_${id}`,
      data: {
        first_name: user?.first_name,
        last_name: user?.last_name,
        email: user?.email,
      },
    });
  }, [user]);

  const dwLogsForReferal = () => {
    // dwLogging(
    //   {
    //     "": AllUrls?.dwLoggingUrl,
    //   },
    //   {
    //     sessionId:
    //       userData?.sessionId || sessionStorage?.getItem("sessionId") || "",
    //     stepName: EC_DW_LOGGING_STEPS?.referalClicked,
    //     cta: "Success",
    //     userEmail: userData?.data?.email,
    //     customerType: userData?.companyName || "",
    //     billingType: userData?.data?.billingType || ""
    //   },
    //   headers
    // );
       DwLogutil({ stepName: EC_DW_LOGGING_STEPS?.referalClicked});
  };

  return (
    <Typography onClick={dwLogsForReferal}>
      <span id={`extole_zone_web_account_management_${id}`}></span>
    </Typography>
  );
};
